import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"fixed-header":"","footer-props":_vm.footerProps,"height":_vm.tableHeight,"options":_vm.options,"customFilter":_vm.customSearch},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.himmokuMei",fn:function(ref){
var value = ref.value;
return [_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(_vm._s(value))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(value))])])]}},{key:"item.dekidakaSuryo",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value.toLocaleString('ja', { minimumFractionDigits: 0, maximumFractionDigits: 0, }))+" ")]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('G_080_KojoDekidakaEntry_ChildActionsBtn',{on:{"info":function () { return _vm.$emit('info', item); },"edit":function () { return _vm.$emit('edit', item); }}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }